import React from "react";
import Navbar from "../components/Navbar";
import Sidebar from "../components/Sidebar";

function SupervisorDashboard() {

  const dashboardData = {
    assignedPlots: 25,
    visitsToday: 8,
    pendingTasks: 6,
    completedTasks: 19
  };

  return (
    <div>

      <Navbar />
      <Sidebar />

      <div
        style={{
          marginLeft: "250px",
          padding: "90px 30px 30px"
        }}
      >

        <h1>
          Supervisor Dashboard
        </h1>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(4,1fr)",
            gap: "20px",
            marginTop: "20px"
          }}
        >

          <div className="stats-card">
            <h3>Assigned Plots</h3>
            <h1>{dashboardData.assignedPlots}</h1>
          </div>

          <div className="stats-card">
            <h3>Visits Today</h3>
            <h1>{dashboardData.visitsToday}</h1>
          </div>

          <div className="stats-card">
            <h3>Pending Tasks</h3>
            <h1>{dashboardData.pendingTasks}</h1>
          </div>

          <div className="stats-card">
            <h3>Completed Tasks</h3>
            <h1>{dashboardData.completedTasks}</h1>
          </div>

        </div>

        <div
          style={{
            background: "white",
            marginTop: "30px",
            padding: "20px",
            borderRadius: "10px"
          }}
        >

          <h2>Today's Visits</h2>

          <ul>
            <li>Plot S253 - Watering Check</li>
            <li>Plot F412 - Fence Inspection</li>
            <li>Plot Q330 - Plantation Review</li>
          </ul>

        </div>

      </div>

    </div>
  );
}

export default SupervisorDashboard;